import {lazy} from "react"
export const Inicio= lazy(()=> import(/* webpackChunkName: "home" */"./Inicio"))
export const Encuesta= lazy(()=> import(/* webpackChunkName: "encuesta" */"./Encuesta"))